<ng-content></ng-content>
<atlas-top-bar-items
  [dropdownItems]="dropdownItems()"
  [hideCenters]="hideCenters()"
  [hideUserDropdown]="hideUserDropdown()"
  [hideNotifications]="hideNotifications()"
  [hideLanguageSelector]="hideLanguageSelector()"
></atlas-top-bar-items>
